import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { queryKey } from '../../../constant/queryKey';
import { useGoodsSno } from '../../../hooks/useGoodsSno';
import { goodsService } from 'shared/src/api';

export const usePreloadRelatedGoods = () => {
  const client = useQueryClient();
  const goodsSno = useGoodsSno();

  useEffect(() => {
    client.prefetchQuery({
      queryKey: queryKey.relatedGoods(goodsSno),
      queryFn: () => goodsService.getRelatedGoods(goodsSno),
    });
  }, [client, goodsSno]);
};
